import { render, staticRenderFns } from "./Fruits.vue?vue&type=template&id=0e43294b&scoped=true&"
import script from "./Fruits.vue?vue&type=script&lang=js&"
export * from "./Fruits.vue?vue&type=script&lang=js&"
import style0 from "./Fruits.vue?vue&type=style&index=0&id=0e43294b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e43294b",
  null
  
)

export default component.exports